import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
import Address from "../../img/address.png";
import { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { ThemeContext } from "../../context";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_nod48vo",
        "template_9gyao3o",
        formRef.current,
        "waifOwH-T0ZK6YdvK"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true)
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c" id="contact">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Get Connected</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              Ask for it
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              xoudeen@gmail.com
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
              Suncity, Old Sinamangal, Kathmandu, Nepal
            </div>

            <div className="c-info-item">
            <ul className="social">
            <li><a href="https://www.linkedin.com/in/santosh-thapa-449926146/" ><i className="fa-brands fa-linkedin" aria-hidden="true"></i> </a></li>
          <li><a   href="https://www.instagram.com/shauntoshh/"><i className="fa-brands fa-instagram" aria-hidden="true"></i> </a></li>

          </ul>
          </div>
          </div>
        </div>
        <div className="c-right">
          <p className="c-desc">
            <b>What’s your story?</b> Get in touch.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Name" name="user_name" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Subject" name="user_subject" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Email" name="user_email" />
            <textarea style={{backgroundColor: darkMode && "#333"}} rows="5" placeholder="Message" name="message" />
            <button>Submit</button>
            {done && "Thank you. Will Contact Soon."}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
